import { render, staticRenderFns } from "./RRHHMain.vue?vue&type=template&id=53caa0a3"
import script from "./RRHHMain.vue?vue&type=script&lang=js"
export * from "./RRHHMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports